import type { ComponentType, Ref, SVGAttributes } from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';

import style from '@core/Page/LeftMenu/NavigationItem/NavigationItem.module.scss';

import { IconType, IconTypeToComponentMap } from '@components/Icon/IconType';

interface Props {
    title: any;
    dataTest: string;
    link: string;
    blank?: boolean;
    iconType?: IconType;
    icon?: ComponentType<SVGAttributes<SVGElement>>;
    isSubItem?: boolean;
    isActive?: boolean;
    ref?: Ref<HTMLAnchorElement>;
    onLinkClick(): void;
}

export function NavigationItem({
    title,
    link,
    blank,
    iconType,
    icon,
    isSubItem,
    isActive,
    ref,
    onLinkClick,
    dataTest,
}: Props) {
    const IconComponent = icon ?? (iconType ? IconTypeToComponentMap[iconType] : undefined);

    const linkContent = () => {
        return (
            <>
                <div className={style.icon}>{IconComponent && <IconComponent />}</div>

                <div className={classnames([style.title])}>{title}</div>
            </>
        );
    };

    return blank ? (
        <a
            ref={ref}
            href={link}
            className={classnames([style.root, isSubItem && style.subItem])}
            data-test={dataTest}
            data-testid={dataTest}
            target={'_blank'}
        >
            {linkContent()}
        </a>
    ) : (
        <NavLink
            ref={ref}
            to={link}
            className={({ isActive: isRouteActive }) =>
                classnames([style.root, isSubItem && style.subItem, (isActive ?? isRouteActive) && style.active])
            }
            onClick={blank ? undefined : onLinkClick}
            target={blank ? '_blank' : undefined}
            draggable={false}
            data-test={dataTest}
            data-testid={dataTest}
        >
            {linkContent()}
        </NavLink>
    );
}
